import {StylizedMenuItem} from './StylizedMenuItem';
import { withErrorBoundary } from '../../SystemComponent/ErrorBoundary';

export default withErrorBoundary('StylizedMenuList')(StylizedMenuItem);
